
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AppBanner extends Vue {
    @Prop({ default: true }) closable!: boolean;

    dismissed: boolean = false;

    close() {
        this.dismissed = true;
    }

};
